import { createFileRoute } from '@tanstack/react-router';
import { TransactionalSetupRouteView } from '@/pages/workspaces/transactional/message/setup/routing';

function TransactionalSetupRoute() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalSetupRouteView transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/setup',
)({
  component: TransactionalSetupRoute,
});
